export default __webpack_public_path__ + "static/media/articles-main-init.489f5120.jpg";